import type { StoreSyncPart, StoreSyncStatus } from '../models/StoreSyncStatus'
import {
  StoreSyncStatusResponseSchema,
  mapDTOToStoreSyncStatus
} from './DTOs/StoreSyncStatusDTO'
import CPBaseGateway from '~/shared/gateways/CPBaseGateway'

export class CPStoreSyncGateway extends CPBaseGateway {
  async getStatus (appId: number): Promise<StoreSyncStatus | null> {
    const response = await this.get<unknown>(`apps/${appId}/store/sync/status`)
    const parsed = StoreSyncStatusResponseSchema.safeParse(response?.data)
    if (!parsed.success) {
      return null
    }
    return mapDTOToStoreSyncStatus(parsed.data.data)
  }

  async sync (appId: number, parts: StoreSyncPart[] | ['all']): Promise<StoreSyncStatus | null> {
    const response = await this.post<unknown>(`apps/${appId}/store/sync`, { parts })
    const parsed = StoreSyncStatusResponseSchema.safeParse(response?.data)
    if (!parsed.success) {
      return null
    }
    return mapDTOToStoreSyncStatus(parsed.data.data)
  }
}
